import { useEffect, useRef } from 'react';

export function useMessageActionOverlay({ onClose, originRef }) {
	const firstItemRef = useRef(null);

	useEffect(() => {
		firstItemRef.current?.focus?.();
	}, []);

	useEffect(() => {
		const onKeyDown = (e) => {
			if (e.key !== 'Escape') return;

			e.stopImmediatePropagation();
			onClose();
			originRef.current?.focus?.();
		};

		document.addEventListener('keydown', onKeyDown);

		return () => document.removeEventListener('keydown', onKeyDown);
	}, [onClose, originRef]);

	useEffect(() => {
		const onScroll = () => onClose();

		document.addEventListener('scroll', onScroll, { capture: true, passive: true });

		return () => document.removeEventListener('scroll', onScroll, { capture: true });
	}, [onClose]);

	useEffect(() => {
		const onResize = () => onClose();

		window.addEventListener('resize', onResize);

		return () => window.removeEventListener('resize', onResize);
	}, [onClose]);

	const handleAction = (onClick) => {
		onClick?.();
		onClose();
		originRef.current?.focus?.();
	};

	return { firstItemRef, handleAction };
}
